import { baseApi } from './baseApi';
import { ServiceTypes } from '../constants';

export const ccmsService = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getCCMSTypes: builder.query<any[], { url: string }>({
      query: ({ url }) => url,
      transformResponse: (result: IApiResponse<any[]>) => result.data,
      providesTags: (result, error, { url }) => [{ type: ServiceTypes.CCMS }],
    }),

    deleteCmsScopeType: builder.mutation<void, { cmsScopeId: number; typeId: number }>({
      query: ({ cmsScopeId, typeId }) => ({
        url: `/cms-scopes/${cmsScopeId}/types/${typeId}`,
        method: 'DELETE',
      }),
      invalidatesTags: () => [{ type: 'Types' }, { type: 'Types', id: 'LIST' }],
    }),
  }),
});

export const { useGetCCMSTypesQuery, useDeleteCmsScopeTypeMutation } = ccmsService;
